export var TAB_FEMALE = '2';
export var TAB_MALE = '3';
export var FILTER_TAB_NONE = 'SHOW_NONE';
export var FILTER_TAB_CATEGORIES = 'SHOW_CATEGORIES';
export var FILTER_TAB_SIZE = 'SHOW_SIZE';
export var FILTER_TAB_BRAND = 'SHOW_BRAND';
export var FILTER_TAB_COLOR = 'SHOW_COLOUR';
export var FILTER_TAB_MATERIAL = 'SHOW_MATERIAL';
export var FILTER_TAB_PRICE = 'SHOW_PRICE';
export var FILTER_TAB_SORT = 'SHOW_SORT';
export var FILTER_TAB_ALL = 'SHOW_ALL';
export var CATEGORY_TAB_SELECTOR_ID = 'category-tab-selector';
